module.exports = __webpack_public_path__ + "static/gpx4-db4dea29706b92a3f2789b24d992263c.png";